import React, { Fragment } from 'react'
import { skin, GAEvent } from 'Utils'
import PropTypes from 'prop-types'
import { LabeledCheckbox, Title, Link } from 'Blocks'
import skins from './skins'
import { gaSelectors } from 'Config'

const Options = props => {
  const {
    selectedItemsCount,
    selectedItemsLabel,
    clearStoresLink,
    clearLabel
  } = props

  return (
    <div className="options">
      <div className="selected-items">
        {`${selectedItemsCount} ${selectedItemsLabel}`}
      </div>
      <div className="clear-label">
        <Link to={clearStoresLink}>{clearLabel}</Link>
      </div>
    </div>
  )
}

Options.propTypes = {
  clearLabel: PropTypes.any,
  clearStoresLink: PropTypes.any,
  selectedItemsCount: PropTypes.any,
  selectedItemsLabel: PropTypes.any
}

const StoreList = props => {
  return (
    <ul className="list">
      {props.items.map(({ id, label, to, isSelected }) => (
        <li key={id} className="list-item">
          {!isSelected ? (
            <GAEvent
              category={gaSelectors.getStoreFilterSettings.category}
              action={gaSelectors.getStoreFilterSettings.action}
              label={`filterStoreName=${label}`}
              additionalProps={{ filterStoreName: label }}
            >
              <LabeledCheckbox
                className="labeled-checkbox"
                {...{ label, to, isSelected }}
              />
            </GAEvent>
          ) : (
            <LabeledCheckbox
              className="labeled-checkbox"
              {...{ label, to, isSelected }}
            />
          )}
        </li>
      ))}
    </ul>
  )
}

StoreList.propTypes = {
  items: PropTypes.array
}

const StoreFilter = props => {
  const { className, style, withTitle } = props

  return (
    <Fragment>
      {withTitle && <Title hasDownArrow>Stores</Title>}
      <div {...{ className, style }}>
        <Options {...props} />
        <StoreList {...props} />
      </div>
    </Fragment>
  )
}

StoreFilter.defaultProps = {
  items: [],
  clearLabel: 'Clear All',
  selectedItemsLabel: 'selected',
  selectedItemsCount: 0,
  withTitle: false
}

// Proptypes needs to be checked
StoreFilter.propTypes = {
  className: PropTypes.any,
  clearLabel: PropTypes.string,
  items: PropTypes.array,
  selectedItemsCount: PropTypes.number,
  selectedItemsLabel: PropTypes.string,
  style: PropTypes.any,
  withTitle: PropTypes.bool
}

export default skin(StoreFilter, skins)
